<template>
	<div class="increment">
		<div class="increment-page-content">
			<div class="title">就诊流程-常规检查结果</div>
			<div class="content">
				<div class="clearfix">
					<quill-editor ref="myTextEditor" v-model="data.remark" :options="editorOpt"
					              style="height:260px; padding-bottom: 65px;"></quill-editor>
				</div>
				<div class="footer">
					<a-button @click="submit()" :loading="isHttpSubmit" style="width:100px" type="primary">确定</a-button>
					<a-button
							@click="closeModel"
							style="width:100px;margin-left:16px;"
							class="ant-btn-custom"
					>取消
					</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import {quillEditor} from 'vue-quill-editor'
  // toolbar工具栏的工具选项（默认展示全部）
  const toolOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['clean'],

  ];
  export default {
    props: {
      data: {
        type: Object,
        default: () => {
          return {
            remark: ""
          };
        }
      }
    },
    components: {quillEditor},
    data() {
      return {
        isHttpSubmit: false,
        editorOpt: {
          placeholder: '编辑常规检查结果',
          theme: 'snow',  // 主题
          modules: {
            toolbar: {
              container: toolOptions,  // 工具栏选项
            }
          }
        },
      };
    },
    mounted() {
    },
    methods: {
      submit() {
        this.isHttpSubmit = true;
        if (!this.data.remark) {
          this.isHttpSubmit = false;
          return;
        }
        this.$put("patientitem/patientItem", this.data, {
          "Content-Type": "application/json"
        }).then(
          res => {
            if (res.data.code == 1) {
              this.$message.success("常规检查结果保存成功!");
              this.$emit("close");
            } else {
              this.isHttpSubmit = false;
              this.$message.error(res.data.message);
            }
          },
          error => {
            this.isHttpSubmit = false;
          }
        );
      },
      closeModel() {
        this.$emit("close");
      },
      onChange(e) {
      }
    }
  };
</script>

<style lang="scss" scoped>
	.increment {
		width: 100%;
		height: 100%;
		background: #fff;
		overflow: auto;
		.increment-page-content {
			width: 682px;
			margin: 80px auto 40px;
			.title {
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
				margin-bottom: 50px;
			}
			/deep/ .content {
				padding: 0 0 15px 0;
				width: 100%;
				.ant-radio-wrapper + .ant-radio-wrapper {
					margin-left: 99px;
				}
				.increment-textarea {
					height: 202px;
					position: relative;
					margin: 22px 0 14px 0;
					.input-message {
						font-size: 12px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(164, 164, 164, 1);
						position: absolute;
						bottom: 10px;
						right: 10px;
						z-index: 2;
					}
					textarea {
						height: 202px;
						resize: none;
					}
				}
			}
			.footer {
				width: 100%;
				margin-top: 20px;
			}
		}
	}
</style>